<!-- <form class="form-change" [formGroup]="autoCompleteForm"> -->
<mat-form-field appearance="fill">
  <img
    *ngIf="value?.id && showProfileImage"
    class="profile-image"
    [src]="'https://profile-images.internal.brafton.com/profile-images/profile-image-' + value?.id + '.jpg'"
  />

  <input
    #profileInput
    type="text"
    matInput
    [formControl]="myControl"
    [required]="true"
    placeholder="Select User"
    [matAutocomplete]="autoGroup"
    (blur)="inputTouched()"
    [value]="getInputBoxValue()"
    [disabled]="disabled"
  />
  <!-- (input)="onChange($event.target.value)" -->
  <mat-icon matSuffix>expand_more</mat-icon>
  <mat-autocomplete #autoGroup="matAutocomplete">
    <mat-option *ngFor="let user of filteredUsers | async" [value]="user.displayName" (click)="selectUser(user)">
      <!-- <mat-icon *ngIf="showProfileImage">

      </mat-icon> -->
      <img
        *ngIf="showProfileImage"
        class="profile-image"
        [src]="'https://profile-images.internal.brafton.com/profile-images/profile-image-' + user?.id + '.jpg'"
      />
      {{user.displayName }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
<!-- </form> -->
